export const setCommissions = (state, commissions) => {
  state.commissions = commissions;
};

export default {
  setCommissions,
};
